<ng-template #blogShare>
  <div class="d-flex align-items-center mt-5 mt-lg-0">
    <span class="me-5">Share</span>
    <div class="d-flex d-lg-flex justify-content-between ">
      <!-- <share-buttons theme="circles-dark" [include]="['whatsapp','email' ,'copy' ]" [showIcon]="true" [showText]="true"
        [url]="url" description="Luminous India share">
      </share-buttons> -->
    </div>
  </div>
</ng-template>

<div class="main-content" *ngIf="blogData && blogData.postTitle">
  <div class="parentContainer">
    <div class="breadcrumbs pt-5 pb-5">
      <span class="d-flex align-items-center"(click)="goBack()">
        <img class="me-4"  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/arrow-left.svg'" alt="Back to Blog | Luminous">
        <span><strong>Back to Blog</strong></span>
      </span>
    </div>
    <div class="resizedimagediv mb-5 d-flex">
      <div class="d-flex flex-column justify-content-start w-100">
        <h1 >{{blogData && blogData?.postTitle ? blogData?.postTitle:''}}</h1>
        <span class="mt-4">{{(blogData && blogData?.postingDate ? blogData?.postingDate:'' )| date : 'MMM dd, YYYY'}}</span>
      </div>
      <img class="mediaImg" loading="lazy" [src]="blogData?.image" alt="Blog Banner | Luminous">
    </div>
    <div class="blogInfo">
      <p class="innerHtmlDiv"
        [innerHTML]="(blogData && blogData?.postDescription ? blogData?.postDescription:'') | safehtml">
      </p>
      <hr class="my-5">
      <div class="blogFooter mt-5 d-lg-flex align-items-center mb-5">
        <div class="d-flex flex-wrap tag-wrapper">
          <span class="me-4" *ngFor="let tag of blogData?.tags">
            {{tag}}
          </span>
        </div>
        <div class="ms-lg-auto">
          <ng-container class="d-block d-lg-none" *ngTemplateOutlet="blogShare"></ng-container>
        </div>
      </div>
    </div>
    </div>
</div>
<div [innerHtml]="structuredData"></div>
